import React from 'react';

interface IconProps {
  size?: number;
  color?: string;
}

export const LinkedInIcon: React.FC<IconProps> = ({
  size = 20,
  color = 'white'
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M22.23 0H1.77C.79 0 0 .774 0 1.727v20.545C0 23.227.79 24 1.77 24h20.46c.98 0 1.77-.773 1.77-1.727V1.727C24 .774 23.21 0 22.23 0ZM7.06 20.452H3.56V9h3.5v11.452ZM5.31 7.433c-1.12 0-2.03-.915-2.03-2.04 0-1.127.91-2.04 2.03-2.04s2.03.913 2.03 2.04c0 1.125-.91 2.04-2.03 2.04ZM20.452 20.452h-3.5v-5.569c0-1.328-.03-3.037-1.85-3.037-1.85 0-2.13 1.445-2.13 2.94v5.666h-3.5V9h3.36v1.561h.05c.47-.89 1.62-1.83 3.33-1.83 3.56 0 4.22 2.344 4.22 5.39v6.331Z" />
    </svg>
  );
};
